<div class="justify-center card bg-base-100">
    <figure><img src="card-images/{{ image }}.jpg" alt="Shoes" /></figure>
    <div class="card-body">
        <h2 class="card-title">
            {{ title }}
            <!-- <div class="badge badge-secondary">NEW</div> -->
        </h2>
        <p>{{ content }}</p>
    </div>
</div>
